module.exports = __webpack_public_path__ + "static/img/sm.b9bbf0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutUP/sm.png
// module id = 4GAt
// module chunks = 1